import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.scss"],
})
export class UploadFileComponent {
  @Input() uploadDataContent: any = [];
  @Input() styleClassName: string = "";
  @Input() isMultiple: boolean = false;
  @Output() actionBrowseButtonCall = new EventEmitter<any>();
  @Output() actionFileDropCall = new EventEmitter<any>();
  @Output() actionCancelCall = new EventEmitter<any>();
  @Input() processingValidation: any;
  @Input() disableFileClose: boolean = false;

  saleFileName: string = "";
  saleFileSize: string = "";

  actionFileBrowse(file: any) {
    this.actionBrowseButtonCall.emit(file);
  }

  onFileDragOver(event: DragEvent) {
    event.preventDefault(); // Enable drop
    event.dataTransfer!.effectAllowed = "copy"; // Allow files to be copied
  }

  onFileDrop(event: DragEvent, callFlag: string = "") {
    event.preventDefault();
    event.dataTransfer!.dropEffect = "copy"; // Indicate copy action
    const files = event.dataTransfer?.files;
    if (files) {
      this.actionFileDropCall.emit({
        file: event,
        type: callFlag,
        fileList: files,
      });
    }
  }

  actionFileClear(type: string) {
    this.actionCancelCall.emit(type);
  }
}
